import { createFetcher } from "api/helpers"

const fetcherConfig = {
  makeRequestUrl: (host, project,params) => {
    return `${host}/infra/${project}/vm_inventory${params?`?${params}`:""}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfig)